module.exports = __webpack_public_path__ + "assets/82ff4c68139060361b4581eab5c16e5e.svg";